import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import Grid from '@material-ui/core/Grid';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';
import Skeleton from '@material-ui/lab/Skeleton';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CountryMFSMapperAddEdit from './CountryMFSMapperAddEdit';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 450,
  },

  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  dialogButtonSection: {
    padding: '8px 20px',
    justifyContent: 'space-between',
  },
  floatRight: {
    position: 'absolute',
    top: 3,
    right: 3,
  },

  imgStyle: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  container: {
    maxHeight: 'calc(100vh - 230px)',
    overflow: 'auto',
  },

  cellWidth: {
    width: '230px',
  },

  tableHeadStyle: {
    '& th': {
      fontWeight: 600,
      fontSize: '1rem',
      backgroundColor: '#000132',
      color: 'white',
    },
  },

  tableBodyStyle: {
    '& td': {
      padding: '8px 16px',
    },
  },
  detailButton: {
    color: '#C3C8C8',
    // margin: '0 5px',
    // border: '1px solid #C3C8C8',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#F1F1F1' },
  },
  editButton: {
    color: '#00C4B4',
    // margin: '0 5px',
    // border: '1px solid #66BD4E',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#00C4B410' },
  },

  titleStyle: {
    marginBottom: '1rem',
  },
  buttonStyle: {
    borderRadius: '25px',
  },
  dialogStyle: {
    width: '400px',
  },
  centerSelectStyle: {
    background: 'wheat',
    borderRadius: '25px',
    // ['& .MuiInputBase-input']: {
    //   color: 'white',
    // },
    [`& fieldset`]: {
      borderRadius: 25,
    },
    [`& .MuiSelect-outlined`]: {
      borderRadius: 25,
      // outline:'auto',
    },
    // [`& .MuiInputLabel-outlined.MuiInputLabel-marginDense`]: {
    //   color: 'white',
    // },
    [`& .MuiInputLabel-outlined.MuiInputLabel-shrink`]: {
      display: 'none',
    },
  },
  alignCenter: {
    textAlign: 'center',
  },
  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));

const CountryMFSMapper = () => {
  const classes = useStyles();
  const { glob_pay_admin_auth, logout, login } = useContext(AuthContext);
  const [list, setList] = useState([]);
  const [detailViewItem, setDetailViewItem] = useState({});
  const [openDetailView, setOpenDetailView] = useState(false);
  const [message, setMessage] = useState("Select a country to see country's MFS mapper list");
  const [loading, setLoading] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [countryId, setCountryId] = useState('');
  const [addDialog, setAddDialog] = useState(false);

  const openAddDialog = () => {
    setAddDialog(true);
  };
  const closeAddDialog = (event, reason) => {
    if (reason && reason == 'backdropClick') return;

    setAddDialog(false);
  };
  // ==================Delete Dialogue start==============================
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const handleDeleteDialogClickOpen = () => {
    setDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
  };
  // ==================Delete Dialogue End==============================

  const handleChange = event => {
    setCountryId(event.target.value);
    getList(event.target.value);
  };

  const handleClickOpenDetailView = () => {
    setOpenDetailView(true);
  };

  const handleCloseDetailView = () => {
    setOpenDetailView(false);
  };

  const handleClickView = item => {
    setDetailViewItem(item);
    handleClickOpenDetailView();
  };

  const getList = async cId => {
    console.log('id', cId);
    setList([]);
    setLoading(true);
    await axios
      .get(`/api/v1/private/country/${cId}/mfs`)
      .then(function(response) {
        console.log('response', response);
        setList(response.data.data);
        if (response.data.data.length < 1) {
          setMessage('No data found in the selected country');
        }
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response.data.error);
      });
    setLoading(false);
  };
  // const getById = async cid => {
  //   await axios
  //     .get(`/api/v1/public/countries/${cid}`)
  //     .then(function(response) {
  //       console.log('res', response);
  //       setEditObj(response.data.data);
  //       openAddDialog();
  //     })
  //     .then()
  //     .catch(function(error) {
  //       // handle error
  //       console.log(error);
  //       // setMessage(error.response.data.error);
  //     });
  // };
  const handleDelete = async () => {
    console.log('handleDeleteID', deleteId);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .delete(`/api/v1/private/country/${countryId}/mfs/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function(response) {
        console.log('response', response);
        let newList = list.filter(res => res.id !== deleteId);
        console.log('newList', newList);
        setList(newList);
        setDeleteDialog(false);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
  const getCountryList = async () => {
    await axios
      .get(`/api/v1/public/countries`)
      .then(function(response) {
        console.log('response', response);
        setCountryList(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response.data.error);
      });
  };
  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 5; i++) {
      content.push(
        <TableRow key={i}>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
        </TableRow>,
      );
    }
    return content;
  };
  useEffect(() => {
    getCountryList();
  }, []);

  return (
    <React.Fragment>
      <Grid container alignItems="center" className={classes.titleStyle}>
        <Grid item md={4}>
          <Typography variant="h2">COUNTRY MFS MAPPER LIST</Typography>
        </Grid>

        <Grid item md={4}>
          <FormControl variant="outlined" size="small" fullWidth className={classes.centerSelectStyle}>
            <InputLabel id="demo-simple-select-outlined-label">Select Country</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={countryId}
              onChange={handleChange}
              // label="Select Country"
            >
              {countryList &&
                countryList.map((item, i) => (
                  <MenuItem value={item.id} key={i}>
                    {item.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={4} style={{ textAlign: 'right' }}>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={openAddDialog}
            startIcon={<AddIcon />}>
            Add New
          </Button>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item md={12}>
          <TableContainer component={Paper} className={classes.container}>
            <Table stickyHeader aria-label="simple table">
              <TableHead className={classes.tableHeadStyle}>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell align="center">Logo</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center" className={classes.cellWidth}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={classes.tableBodyStyle}>
                {list.length > 0
                  ? list.map((row, i) => (
                      <TableRow hover key={i}>
                        <TableCell scope="row">{row.name}</TableCell>
                        <TableCell align="center">
                          <img src={row.logo} alt="" height="30px" />
                        </TableCell>
                        <TableCell align="center">
                          <img src={row.status ? '/images/ok6.svg' : '/images/cross6.svg'} alt="" height="20px" />
                        </TableCell>
                        <TableCell align="center">
                          <IconButton className={classes.detailButton} onClick={() => handleClickView(row)}>
                            <VisibilityIcon />
                          </IconButton>

                          <IconButton
                            color="secondary"
                            onClick={() => {
                              handleDeleteDialogClickOpen();
                              setDeleteId(row.id);
                            }}>
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  : null}
                {!loading && list.length < 1 ? (
                  <TableRow>
                    <TableCell colSpan="4" style={{ textAlign: 'center' }}>
                      <ArrowUpwardIcon
                        size="small"
                        style={{
                          position: 'absolute',
                          marginTop: '-2px',
                          marginLeft: '-18px',
                          border: '1px solid #000132',
                          borderRadius: '5px',
                        }}
                      />
                      &nbsp;&nbsp;&nbsp; {message}
                    </TableCell>
                  </TableRow>
                ) : null}
                {loading && pageLoading()}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        {/* <Grid item md={4}>
          <Paper className={classes.paper}>
            <CountryMFSMapperAddEdit list={list} setList={setList} countryList={countryList} selectedBankId={countryId} />
          </Paper>
        </Grid> */}
      </Grid>

      <div>
        <Dialog
          open={openDetailView}
          onClose={handleCloseDetailView}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent>
            {detailViewItem ? (
              <TableContainer style={{ marginBottom: '40px' }}>
                <div className={classes.titleDiv}>
                  <div className={classes.iconDiv}>
                    <IconButton
                      style={{ background: 'gainsboro' }}
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={handleCloseDetailView}>
                      <Clear fontSize="inherit" />
                    </IconButton>
                  </div>

                  <Typography variant="h1" className={` ${classes.alignCenter}`}>
                    Details
                  </Typography>
                </div>
                <Table className={classes.table} aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan="2" scope="row" style={{ paddingTop: '0px' }}>
                        <img
                          src={detailViewItem.logo ? detailViewItem.logo : ''}
                          alt=""
                          height="80px"
                          className={classes.imgStyle}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Name</TableCell>
                      <TableCell align="right">{detailViewItem.name}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Status</TableCell>
                      <TableCell align="right">
                        {detailViewItem.status ? (
                          <Typography variant="h6" style={{ color: 'green' }}>
                            Available
                          </Typography>
                        ) : (
                          <Typography variant="h6" style={{ color: 'red' }}>
                            Not Available
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
      {/* ==================Add Dialog start============================== */}

      <div>
        <Dialog
          open={addDialog}
          onClose={closeAddDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            {/* <CountryAddEdit
              list={list}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
              closeAddDialog={closeAddDialog}
              addDialog={addDialog}
            /> */}
            <CountryMFSMapperAddEdit
              list={list}
              setList={setList}
              countryList={countryList}
              selectedBankId={countryId}
              closeAddDialog={closeAddDialog}
              addDialog={addDialog}
            />
          </DialogContent>
        </Dialog>
      </div>

      {/* ==================Add Dialog End============================== */}
      {/* ==================Delete Dialogue start============================== */}
      <div>
        <Dialog
          open={deleteDialog}
          onClose={handleDeleteDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              minWidth: '400px',
              boxShadow: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: '20px',
            },
          }}>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography variant="h3">Are you sure to delete ?</Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose} variant="outlined">
              Cancel
            </Button>
            <Button color="secondary" onClick={handleDelete} autoFocus variant="contained">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* ==================Delete Dialogue End============================== */}
    </React.Fragment>
  );
};

export default CountryMFSMapper;
